import * as React from 'react'
import { KlarnaBadge } from './KlarnaBadge'
import { KlarnaLogo } from './KlarnaLogo'

export default {
  badge: <KlarnaBadge/>,
  logo: <KlarnaLogo/>
}
